import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { useNavigate } from "react-router-dom";
import {
  ShopTwoTone,
  RocketTwoTone,
  AppstoreTwoTone,
  CrownTwoTone,
  HighlightTwoTone,
} from "@ant-design/icons";
import { apiCaller } from "src/util/apiCaller";

interface CustomMenuItem {
  key: string;
  icon?: React.ReactNode;
  label: string;
  id: string;
}

const icons = [
  <ShopTwoTone />,
  <AppstoreTwoTone />,
  <CrownTwoTone />,
  <RocketTwoTone />,
  <HighlightTwoTone />,
];

const Navbar: React.FC<{
  keyAttribute: string | undefined;
  setIsDrawerOpen: (open: boolean) => void;
}> = ({ keyAttribute, setIsDrawerOpen }) => {
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState<CustomMenuItem[]>([]);
  const [currentKeyAttribute, setCurrentKeyAttribute] = useState<
    string | undefined
  >(keyAttribute);

  useEffect(() => {
    if (
      keyAttribute &&
      ["tu-lieu", "hinh-anh", "video", "menu-toggle"].includes(keyAttribute)
    ) {
      fetchMenuItems(keyAttribute);
    }
  }, [keyAttribute]);

  const fetchMenuItems = async (key: string) => {
    try {
      const response = await apiCaller({
        url: `/apipublic/nhomtulieus`,
        method: "GET",
      });

      if (response && response.data) {
        const items: CustomMenuItem[] = response.data.content.map(
          (item: any, index: number) => ({
            key: `${key}/idnhomtulieu/${item.id}`,
            label: item.tenNhomTuLieu,
            icon: icons[index % icons.length],
            id: item.id,
          })
        );
        setMenuItems(items);
      }
    } catch (error) {
      console.error("Failed to fetch menu items:", error);
    }
  };

  useEffect(() => {
    const currentPath = window.location.pathname.startsWith("/trang-chu/")
      ? window.location.pathname.replace("/trang-chu/", "")
      : window.location.pathname;
    const validKey = keyAttribute || currentPath;
    if (validKey && ["tu-lieu", "hinh-anh", "video"].includes(validKey)) {
      setCurrentKeyAttribute(currentPath);
      fetchMenuItems(validKey);
    } else {
      setCurrentKeyAttribute(keyAttribute || "/");
    }
  }, [currentKeyAttribute]);

  const onClickMenu = (key: any) => {
    const menuKey = key.key || key;
    const selectedItem = menuItems.find((item) => item.key === menuKey);
    if (menuKey === "/" || menuKey === "/trang-chu") {
      setCurrentKeyAttribute(undefined);
      navigate("/trang-chu");
    } else if (selectedItem) {
      setCurrentKeyAttribute(menuKey);
      const path = `/trang-chu/${menuKey}`;

      navigate(path, {
        state: {
          tenNhomTuLieu: selectedItem.label,
          idNhomTuLieu: selectedItem.id,
        },
      });
    }

    setIsDrawerOpen(false);
  };

  return (
    <Menu
      mode="inline"
      style={{ height: "100%", borderRight: 0 }}
      items={menuItems}
      onClick={onClickMenu}
      selectedKeys={[currentKeyAttribute || "/"]}
    />
  );
};

export default Navbar;
